import React from "react";
import { Link } from "gatsby";

const Footer = class extends React.Component {
  render() {
    return (
      <section className="footy">
        <div className="footer">
          <div className="footer-container">
            <div className="grid2">
              <div className="item-left">
                <div className="address">
                  Opal Digital, White Collar Factory, <br />1 Old Street Yard,
                  Shoreditch, London, EC1Y 8AF
                </div>
                <div className="copyright">
                  <a
                    className="social"
                    target="_blank"
                    href="https://www.linkedin.com/company/opal-digital-ltd/"
                    rel="noopener"
                  >
                    <img src="/img/linkedin.svg" alt="LinkedIn"/>
                  </a>
                  © 2021 Opal Digital. All rights reserved.
                </div>
              </div>
              <div className="item-right">
                <ul>
                  <li>
                    <Link to="/live-jobs">Live Jobs</Link>
                  </li>
                  <li>
                    <Link to="/client-services">Client Services</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li >
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
  
};

export default Footer;
